import React from "react";
import {
  CCard,
  CCardBody,
  CFormInput,
  CFormLabel,
  CCol,
  CRow,
  CContainer,
  CButton,
  CFormSelect,
  CFormSwitch,
} from "@coreui/react";
import { useLocation, useNavigate,  } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateUserAddress } from "../../features/user/userSlice";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AppLoader from "./AppLoader";

const validationSchema = Yup.object().shape({
  addressLine1: Yup.string().required("Address Line 1 is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  postal_code: Yup.string().required("Postal Code is required"),
  region: Yup.string().required("Country is required"),
  address_type: Yup.string().required("Address type is required"),
});

const AddressForm = ({ mode, initialData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const passedData = location.state?.address;
  const { addressLoading } = useSelector((state) => state.user);

  const initialValues = passedData || {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postal_code: "",
    region: "",
    type: "",
    isDefault: false,
    address_type: "",
  };

  const handleSubmit = async (values) => {
      // console.log("Button clicked")
    try {
      // console.log("Submitting address:",values)
      await dispatch(updateUserAddress(values)).unwrap();
      navigate(-1);
    } catch (error) {
      console.error("Address update failed:", error);
    }
  };

  if (addressLoading) {
    return <AppLoader/>;
  }

  return (
    <CContainer fluid className="px-3 mt-4">
      <CCard className="shadow-sm border-0 rounded-4">
        <CCardBody>
          <h4 className="mb-4">
            {mode === "edit" ? "Edit Address" : "Add New Address"}
          </h4>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form>
                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormLabel>Address Line 1</CFormLabel>
                    <Field name="addressLine1" as={CFormInput} />
                    <ErrorMessage
                      name="addressLine1"
                      component="div"
                      className="text-danger small"
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormLabel>Address Line 2</CFormLabel>
                    <Field name="addressLine2" as={CFormInput} />
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormLabel>City</CFormLabel>
                    <Field name="city" as={CFormInput} />
                    <ErrorMessage
                      name="city"
                      component="div"
                      className="text-danger small"
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormLabel>State</CFormLabel>
                    <Field name="state" as={CFormInput} />
                    <ErrorMessage
                      name="state"
                      component="div"
                      className="text-danger small"
                    />
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormLabel>Postal Code</CFormLabel>
                    <Field name="postal_code" as={CFormInput} />
                    <ErrorMessage
                      name="postal_code"
                      component="div"
                      className="text-danger small"
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormLabel>Country</CFormLabel>
                    <Field name="region" as={CFormInput} />
                    <ErrorMessage
                      name="region"
                      component="div"
                      className="text-danger small"
                    />
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormLabel>Address Type</CFormLabel>
                    <CFormSelect
                      name="address_type"
                      value={values.address_type}
                      onChange={handleChange}
                      options={[
                        { label: "Select Type", value: "" },
                        { label: "Office", value: "Office" },
                        { label: "Warehouse", value: "Warehouse" },
                        { label: "Home", value: "Home" },
                      ]}
                    />
                    <ErrorMessage
                      name="address_type"
                      component="div"
                      className="text-danger small"
                    />
                  </CCol>

                  <CCol md={6} className="d-flex align-items-end">
                    <div className="d-flex align-items-center w-100 mb-2">
                      <CFormSwitch
                        id="defaultSwitch"
                        name="isDefault"
                        checked={values.isDefault}
                        onChange={(e) =>
                          setFieldValue("isDefault", e.target.checked)
                        }
                        className="me-2 mb-0"
                      />
                      <label
                        htmlFor="defaultSwitch"
                        className="mb-0 fw-semibold"
                      >
                        Set as default address
                      </label>
                    </div>
                  </CCol>
                </CRow>

                <div className="text-end">
                  <CButton type="submit" color="primary" className="me-2">
                    Save
                  </CButton>
                  <CButton color="secondary" onClick={() => navigate(-1)}>
                    Cancel
                  </CButton>
                </div>
              </Form>
            )}
          </Formik>
        </CCardBody>
      </CCard>
    </CContainer>
  );
};

export default AddressForm;
